import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

function Projects() {
    return (
        <section id="projects">
            <h2>Projects</h2>
            <ul>
                <li>
                    <h3>Project 1</h3>
                    <p><strong>Description:</strong> Brief overview of Project 1.</p>
                    <p><strong>Technologies Used:</strong> Java, Spring Boot</p>
                    <p><strong>Link:</strong> <Link to="/project1">View Project</Link></p>
                </li>
                <li>
                    <h3>Project 2</h3>
                    <p><strong>Description:</strong> Brief overview of Project 2.</p>
                    <p><strong>Technologies Used:</strong> Python, Django</p>
                    <p><strong>Link:</strong> <Link to="/project2">View Project</Link></p>
                </li>
                <li>
                    <h3>Project 3</h3>
                    <p><strong>Description:</strong> Brief overview of Project 3.</p>
                    <p><strong>Technologies Used:</strong> Python, Machine Learning</p>
                    <p><strong>Link:</strong> <Link to="/project3">View Project</Link></p>
                </li>
            </ul>
        </section>
    );
}

export default Projects;
